define('home/templates/forumCover',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<p class=\"cover-description\">\n"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.plainDescription : depth0), depth0))
    + "\n</p>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "<div class=\"section-contained\">\n<div class=\"cover-body\">\n<div class=\"cover-body-left\">\n<div class=\"cover-profile-content\" dir=\"auto\">\n<div class=\"cover-profile-name-wrapper\">\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\" data-link-out=\""
    + alias2(alias1((depth0 != null ? depth0.signedUrl : depth0), depth0))
    + "\"><img class=\"cover-favicon\" src=\""
    + alias2(alias1((depth0 != null ? depth0.faviconImage : depth0), depth0))
    + "\" alt=\""
    + ((stack1 = container.invokePartial(partials.forumName,depth0,{"name":"forumName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\"></a>\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\" data-link-out=\""
    + alias2(alias1((depth0 != null ? depth0.signedUrl : depth0), depth0))
    + "\"><h1 class=\"cover-profile-name truncate-line\">"
    + ((stack1 = container.invokePartial(partials.forumName,depth0,{"name":"forumName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</h1></a>\n<div class=\"cover-profile-action\">\n"
    + ((stack1 = container.invokePartial(partials.genericFollowButton,depth0,{"name":"genericFollowButton","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.plainDescription : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<ul class=\"cover-attributes\">\n<li class=\"cover-attribute\">\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.url : depth0), depth0))
    + "\" data-link-out=\""
    + alias2(alias1((depth0 != null ? depth0.signedUrl : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.friendlyUrl : depth0), depth0))
    + "</a>\n</li>\n</ul>\n<div class=\"cover-profile-action-mobile\">\n"
    + ((stack1 = container.invokePartial(partials.genericFollowButton,depth0,{"name":"genericFollowButton","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"cover-nav-wrapper visible-sidebar\">\n<div class=\"section-contained\">\n<nav class=\"cover-nav cover-nav-profile-user\">\n<ul class=\"cover-nav-options\">\n<li class=\"cover-nav-option active\" data-action=\"switch-tab\" data-tab=\"recent\">\n<a title=\""
    + alias2(helpers.gettext.call(alias3,"Latest Discussions",{"name":"gettext","hash":{},"data":data}))
    + "\" class=\"truncate-line\" href=\"/home/forum/"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "/\">\n<span class=\"hidden-md\">"
    + alias2(helpers.gettext.call(alias3,"Latest Discussions",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n<span class=\"visible-md\">"
    + alias2(helpers.gettext.call(alias3,"Latest",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n</a>\n</li>\n<li class=\"cover-nav-option\" data-action=\"switch-tab\" data-tab=\"commenters\">\n<a title=\""
    + alias2(helpers.gettext.call(alias3,"Top Commenters",{"name":"gettext","hash":{},"data":data}))
    + "\" class=\"truncate-line\" href=\"/home/forum/"
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "/commenters/\">\n<span class=\"hidden-md\">"
    + alias2(helpers.gettext.call(alias3,"Top Commenters",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n<span class=\"visible-md\">"
    + alias2(helpers.gettext.call(alias3,"Commenters",{"name":"gettext","hash":{},"data":data}))
    + "</span>\n</a>\n</li>\n</ul>\n</nav>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
